import { http } from '@/system/http';
import axios from 'axios';
import { ManualAdditionalFields, MessageType } from 'Components/apps/helsenett/HelsenettBusinessLogicData';

// Inbox
export const ACTION_LOAD_INBOX = 'loadInbox';
export const ACTION_CLEAR_INBOX = 'clearInbox';
export const ACTION_ARCHIVE_MESSAGE = 'archiveMessage';
export const ACTION_DELETE_MESSAGE = 'deleteMessage';
export const ACTION_UNARCHIVE_MESSAGE = 'unarchiveMessage';
export const ACTION_ASSIGN_CLIENT = 'assignClient';
export const ACTION_MARK_MESSAGE_AS_READ_IN_FRONTEND = 'markMessageAsReadInFrontend';
const MUTATION_EMPTY_INBOX_MESSAGES = 'emptyInboxMessages';
const MUTATION_ADD_INBOX_MESSAGES = 'addInboxMessages';
const MUTATION_SET_INBOX_LOAD_CANCEL_TOKEN_SOURCE = 'setInboxLoadCancelTokenSource';
const MUTATION_REMOVE_MESSAGES_BY_ID = 'removeMessagesById';
const MUTATION_UPDATE_PATIENT_ASSOCIATION = 'updatePatientAssociation';
const MUTATION_MARK_MESSAGE_READ = 'markMessageAsRead';

const MUTATION_SET_IMPORTED_COMPARTIES_OWN_BUSINESS = 'setImportedCompartiesOwnBusiness';
const MUTATION_SET_IMPORTED_COMPARTIES_CHILDREN_LOADED_OWN_BUSINESS = 'setImportedCompartiesChildrenLoadedOwnBusiness';
const MUTATION_SET_IMPORTED_COMPARTIES_PARTNER_BUSINESS = 'setImportedCompartiesPartnerBusiness';
const MUTATION_SET_IMPORTED_COMPARTIES_CHILDREN_LOADED_PARTNER_BUSINESS = 'setImportedCompartiesChildrenLoadedPartnerBusiness';

// Additional Information
export const ACTION_ADDITIONAL_INFORMATION_LOAD = 'loadAdditionalInformation';
export const ACTION_RESET_UNSAVED_ADDITIONAL_INFORMATION = 'resetUnsavedAdditionalInformation';
export const ACTION_SAVE_ADDITIONAL_INFORMATION = 'saveAdditionalInformation';
export const ACTION_GET_SUBMIT = 'getSubmit';
export const ACTION_REFERRAL_SET_ADDITIONAL_FIELDS = 'ACTION_REFERRAL_SET_ADDITIONAL_FIELDS';
export const ACTION_REFERRAL_SYNC_VISIBLE_FIELDS = 'ACTION_REFERRAL_SYNC_VISIBLE_FIELDS';
export const ACTION_REFERRAL_SYNC_HAS_ADDITIONAL_INFORMATION = 'ACTION_REFERRAL_SYNC_HAS_ADDITIONAL_INFORMATION';
export const ACTION_CLEAR_ADDITIONAL_INFORMATION = 'ACTION_CLEAR_ADDITIONAL_INFORMATION';
const MUTATION_UPDATE_ADDITIONAL_INFORMATION = 'updateAdditionalInformation';
const MUTATION_RESET_UNSAVED_ADDITIONAL_INFORMATION = 'resetUnsavedAdditionalInformation';
const MUTATION_COMMIT_ADDITIONAL_INFORMATION = 'commitAdditionalInformation';
const MUTATION_CLEAR_ADDITIONAL_INFORMATION = 'clearAdditionalInformation';

const MUTATION_COMMIT_REFERRAL_ADDITIONAL_INFORMATION_ON_PATIENT = 'mutationCommitReferralAdditionalInformationOnPatient';
const MUTATION_COMMIT_REFERRAL_PATIENT_RELATED_CONTACT_PERSON = 'mutationCommitReferralPatientRelatedContactPerson';
const MUTATION_COMMIT_REFERRAL_NEXT_OF_KIN_GUARDIAN = 'mutationCommitReferralNextOfKinGuardian';
const MUTATION_COMMIT_REFERRAL_ASSOCIATED_UNIT = 'mutationCommitReferralAssociatedUnit';
const MUTATION_COMMIT_INFO_ASSISTED_COMMUNICATION = 'mutationCommitInfoAssistedCommunication';
const MUTATION_COMMIT_EVALUATION_OF_REFERRAL = 'mutationCommitEvaluationOfReferral';
const MUTATION_COMMIT_INFORMATION_ABOUT_INDIVIDUAL_PLAN = 'mutationCommitInformationAboutIndividualPlan';
const MUTATION_COMMIT_SENT_DOCUMENT = 'mutationCommitSendDocument';
const MUTATION_COMMIT_INF_ITEMS = 'mutationCommitInfItems';
const MUTATION_COMMIT_REASON_AS_TEXTS = 'mutationCommitReasonAsTexts';
const MUTATION_COMMIT_DATE_OF_RECEIPT_EVALUATION = 'mutationCommitDateOfReceiptEvaluation';
const MUTATION_COMMIT_REFERRAL_HIDE_ALL_FIELDS = 'mutationCommitReferralHideAllFields';
const MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY = 'mutationCommitReferralManualFieldVisibility';
const MUTATION_REFERRAL_SET_HAS_ADDITIONAL_INFORMATION = 'mutationReferralSetHasAdditionalInformation';

export default {
    state: {
        ownBusiness: {
            importedComparties: [],
            importedCompartiesChildrenLoaded: false,
        },
        partnerBusiness: {
            importedComparties: [],
            importedCompartiesChildrenLoaded: false,
        },
        /**
         * See the comment on `getMessageStorageKey` for more info of how the messages are keyed in this map.
         */
        messages: {},
        inboxLoadCancelTokenSource: null,

        /**
         * If we have any additional fields visible.
         */
        hasAdditionalInformation: false,

        /**
         * The message type that the additional informaiton is currently loaded for.
         */
        additionalInformationMessageType: null,

        /**
         * Todo
         */
        additionalInformation: {
            infItems: null,
            reasonAsTexts: null,
            typeContentMessage: null,
            languageTypes: null,
            waitingTimeEndCode: null,
            outcomeOfEvaluation: null,
            dateOfReceiptEvaluation: null,
            sendDocumentInformation: null,
            sendDocumentTypeRecipient: null,
            manual: null,
        },

        admissionTypes: null,
        maritalStatuses: null,
        relationshipTypes: null,
        guardianTypes: null,
        addressTypes: null,

        unsavedAdditionalInformation: {
            infItems: null,
            reasonAsTexts: null,
            manual: null,
        },

        referralNewState: {
            referral: {
                patientRelatedContactPerson: null,
                additionalInformationOnPatient: null,
                nextOfKinGuardian: null,
                associatedUnit: null,
                infoAssistedCommunication: null,
                informationAboutIndividualPlan: null,
                sendDocument: null,
                evaluationOfReferral: null, // Only referral forward
            },
        },
    },

    mutations: {
        [MUTATION_SET_IMPORTED_COMPARTIES_OWN_BUSINESS](state, comparties) {
            state.ownBusiness.importedComparties = comparties;
        },

        [MUTATION_SET_IMPORTED_COMPARTIES_CHILDREN_LOADED_OWN_BUSINESS](state, childrenLoaded) {
            state.ownBusiness.importedCompartiesChildrenLoaded = childrenLoaded;
        },

        [MUTATION_SET_IMPORTED_COMPARTIES_PARTNER_BUSINESS](state, comparties) {
            state.partnerBusiness.importedComparties = comparties;
        },

        [MUTATION_SET_IMPORTED_COMPARTIES_CHILDREN_LOADED_PARTNER_BUSINESS](state, childrenLoaded) {
            state.partnerBusiness.importedCompartiesChildrenLoaded = childrenLoaded;
        },

        [MUTATION_EMPTY_INBOX_MESSAGES](state) {
            state.messages = {};
        },

        [MUTATION_ADD_INBOX_MESSAGES](state, messages) {
            for (const message of messages) {
                const storageKey = getMessageStorageKey(message.messageId);
                state.messages[storageKey] = message;
            }
        },

        [MUTATION_SET_INBOX_LOAD_CANCEL_TOKEN_SOURCE](state, source) {
            state.inboxLoadCancelTokenSource = source;
        },

        [MUTATION_REMOVE_MESSAGES_BY_ID](state, ids) {
            for (const id of ids) {
                const storageKey = getMessageStorageKey(id);
                if (!state.messages[storageKey]) {
                    continue;
                }
                state.messages.splice(storageKey, 1);
            }
        },

        [MUTATION_MARK_MESSAGE_READ](state, id) {
            const storageKey = getMessageStorageKey(id);
            const message = state.messages[storageKey];
            if (!message) {
                throw new Error('Assertion Failed: No message with id "' + id + '" in the store.');
            }
            message.isRead = true;
        },

        [MUTATION_UPDATE_PATIENT_ASSOCIATION](state, { messageId, patientAssociation }) {
            const storageKey = getMessageStorageKey(messageId);
            const message = state.messages[storageKey];
            if (!message) {
                throw new Error('Assertion Failed: No message with id "' + messageId + '" in the store.');
            }
            message.patientAssociation = patientAssociation;
        },

        [MUTATION_UPDATE_ADDITIONAL_INFORMATION](state, { messageType, data }) {
            state.additionalInformationMessageType = messageType;

            // Merge infItems loaded from message, and available infItems.
            // TODO: This works but is really ugly! Clean this up in a follow-up. This logic should be moved
            //       into ACTION_REFERRAL_SYNC_VISIBLE_FIELDS.
            {
                const existingInfItems = structuredClone(state.additionalInformation.infItems);
                state.additionalInformation.infItems = data.typeCodes.infItems;
                if (existingInfItems) {
                    for (const existingInfItem of existingInfItems) {
                        const index = state.additionalInformation.infItems.findIndex(x => x.value === existingInfItem.value);
                        state.additionalInformation.infItems[index].inputText = existingInfItem.inputText;

                        // If the field is hidden but was loaded via the message, then we want to show it.
                        if (state.additionalInformation.infItems[index].visibility === 'hidden') {
                            state.additionalInformation.infItems[index].visibility = 'once';
                        }
                    }
                }
            }

            // Merge reasonAsTexts loaded from message, and available reasonAsTexts.
            // TODO: This works but is really ugly! Clean this up in a follow-up. This logic should be moved
            //       into ACTION_REFERRAL_SYNC_VISIBLE_FIELDS.
            {
                const existingReasonAsTexts = structuredClone(state.additionalInformation.reasonAsTexts);
                state.additionalInformation.reasonAsTexts = data.typeCodes.reasonAsTexts;
                if (existingReasonAsTexts) {
                    for (const existingReasonAsText of existingReasonAsTexts) {
                        const index = state.additionalInformation.reasonAsTexts.findIndex(x => x.value === existingReasonAsText.value);
                        state.additionalInformation.reasonAsTexts[index].inputText = existingReasonAsText.inputText;

                        // If the field is hidden but was loaded via the message, then we want to show it.
                        if (state.additionalInformation.reasonAsTexts[index].visibility === 'hidden') {
                            state.additionalInformation.reasonAsTexts[index].visibility = 'once';
                        }
                    }
                }
            }

            // Merge dateOfReceiptEvaluation loaded from message, and available dateOfReceiptEvaluation.
            // TODO: This works but is really ugly! Clean this up in a follow-up. This logic should be moved
            //       into ACTION_REFERRAL_SYNC_VISIBLE_FIELDS.
            {
                const existingDateOfReceiptEvaluation = structuredClone(state.additionalInformation.dateOfReceiptEvaluation);
                state.additionalInformation.dateOfReceiptEvaluation = data.typeCodes.dateOfReceiptEvaluation;
                if (existingDateOfReceiptEvaluation) {
                    for (const item of existingDateOfReceiptEvaluation) {
                        const index = state.additionalInformation.dateOfReceiptEvaluation.findIndex(x => x.value === item.value);
                        state.additionalInformation.dateOfReceiptEvaluation[index].date = item.date;

                        // If the field is hidden but was loaded via the message, then we want to show it.
                        if (state.additionalInformation.dateOfReceiptEvaluation[index].visibility === 'hidden') {
                            state.additionalInformation.dateOfReceiptEvaluation[index].visibility = 'once';
                        }
                    }
                }
            }

            state.additionalInformation.typeContentMessage = data.typeCodes.typeContentMessage;
            state.additionalInformation.languageTypes = data.typeCodes.languageTypes;
            state.additionalInformation.waitingTimeEndCode = data.typeCodes.waitingTimeEndCode;
            state.additionalInformation.outcomeOfEvaluation = data.typeCodes.outcomeOfEvaluation;
            state.additionalInformation.sendDocumentInformation = data.typeCodes.sendDocumentInformation;
            state.additionalInformation.sendDocumentTypeRecipient = data.typeCodes.sendDocumentTypeRecipient;
            state.additionalInformation.manual = data.manual;
            state.admissionTypes = data.admissionTypes;
            state.maritalStatuses = data.maritalStatuses;
            state.relationshipTypes = data.relationshipTypes;
            state.guardianTypes = data.guardianTypes;
            state.addressTypes = data.addressTypes;
        },

        [MUTATION_RESET_UNSAVED_ADDITIONAL_INFORMATION](state) {
            state.unsavedAdditionalInformation.infItems = structuredClone(state.additionalInformation.infItems);
            state.unsavedAdditionalInformation.reasonAsTexts = structuredClone(state.additionalInformation.reasonAsTexts);
            state.unsavedAdditionalInformation.manual = structuredClone(state.additionalInformation.manual);
        },

        [MUTATION_COMMIT_ADDITIONAL_INFORMATION](state) {
            state.additionalInformation.infItems = structuredClone(state.unsavedAdditionalInformation.infItems);
            state.additionalInformation.reasonAsTexts = structuredClone(state.unsavedAdditionalInformation.reasonAsTexts);
            state.additionalInformation.manual = structuredClone(state.unsavedAdditionalInformation.manual);
        },

        [MUTATION_COMMIT_REFERRAL_ADDITIONAL_INFORMATION_ON_PATIENT](state, data) {
            state.referralNewState.referral.additionalInformationOnPatient = data;
        },

        [MUTATION_COMMIT_REFERRAL_PATIENT_RELATED_CONTACT_PERSON](state, data) {
            state.referralNewState.referral.patientRelatedContactPerson = data;
        },

        [MUTATION_COMMIT_REFERRAL_NEXT_OF_KIN_GUARDIAN](state, data) {
            state.referralNewState.referral.nextOfKinGuardian = data;
        },

        [MUTATION_COMMIT_REFERRAL_ASSOCIATED_UNIT](state, data) {
            state.referralNewState.referral.associatedUnit = data;
        },

        [MUTATION_COMMIT_INFO_ASSISTED_COMMUNICATION](state, data) {
            state.referralNewState.referral.infoAssistedCommunication = data;
        },

        [MUTATION_COMMIT_INFORMATION_ABOUT_INDIVIDUAL_PLAN](state, data) {
            state.referralNewState.referral.informationAboutIndividualPlan = data;
        },

        [MUTATION_COMMIT_SENT_DOCUMENT](state, data) {
            state.referralNewState.referral.sendDocument = data;
        },

        [MUTATION_COMMIT_EVALUATION_OF_REFERRAL](state, data) {
            state.referralNewState.referral.evaluationOfReferral = data;
        },

        [MUTATION_COMMIT_INF_ITEMS](state, infItems) {
            state.additionalInformation.infItems = infItems;
        },

        [MUTATION_COMMIT_REASON_AS_TEXTS](state, reasonAsTexts) {
            state.additionalInformation.reasonAsTexts = reasonAsTexts;
        },

        [MUTATION_COMMIT_DATE_OF_RECEIPT_EVALUATION](state, dateOfReceiptEvaluation) {
            state.additionalInformation.dateOfReceiptEvaluation = dateOfReceiptEvaluation;
        },

        [MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY](state, { fieldId, visibility }) {
            const field = state.additionalInformation.manual.find(x => x.fieldId === fieldId);
            if (field) {
                field.visibility = visibility;
            }
        },

        [MUTATION_COMMIT_REFERRAL_HIDE_ALL_FIELDS](state) {
            if (state.additionalInformation && state.additionalInformation.manual) {
                for (const field of state.additionalInformation.manual) {
                    field.visibility = 'hidden';
                }
            }
        },

        [MUTATION_REFERRAL_SET_HAS_ADDITIONAL_INFORMATION](state, b) {
            state.hasAdditionalInformation = b;
        },

        [MUTATION_CLEAR_ADDITIONAL_INFORMATION](state) {
            state.additionalInformation.infItems = null;
            state.additionalInformation.reasonAsTexts = null;
            state.additionalInformation.typeContentMessage = null;
            state.additionalInformation.languageTypes = null;
            state.additionalInformation.waitingTimeEndCode = null;
            state.additionalInformation.outcomeOfEvaluation = null;
            state.additionalInformation.dateOfReceiptEvaluation = null;
            state.additionalInformation.sendDocumentInformation = null;
            state.additionalInformation.sendDocumentTypeRecipient = null;
            state.additionalInformation.manual = null;

            state.hasAdditionalInformation = false;
        },
    },

    getters: {
        importedCompartiesOwnBusiness(state) {
            return state.ownBusiness.importedComparties;
        },

        importedCompartiesPartnerBusiness(state) {
            return state.partnerBusiness.importedComparties;
        },

        getMessageById: (state) => (id) => {
            const storageKey = getMessageStorageKey(id);
            return state.messages[storageKey];
        },
    },

    actions: {
        async loadImportedComparties(context, { loadChildren, ownBusiness, refresh = false }) {

            if (!refresh) {
                if (ownBusiness) {
                    if (
                        context.state.ownBusiness.importedComparties.length > 0 &&
                        context.state.ownBusiness.importedCompartiesChildrenLoaded === loadChildren
                    ) {
                        return;
                    }
                } else {
                    if (
                        context.state.partnerBusiness.importedComparties.length > 0 &&
                        context.state.partnerBusiness.importedCompartiesChildrenLoaded === loadChildren
                    ) {
                        return;
                    }
                }
            }

            const response = await http.get('/app/helsenett/comparties', {
                params: {
                    children: loadChildren,
                    ownBusiness: ownBusiness,
                },
            });

            if (ownBusiness) {
                context.commit(MUTATION_SET_IMPORTED_COMPARTIES_OWN_BUSINESS, response.data);
                context.commit(MUTATION_SET_IMPORTED_COMPARTIES_CHILDREN_LOADED_OWN_BUSINESS, loadChildren);
            } else {
                context.commit(MUTATION_SET_IMPORTED_COMPARTIES_PARTNER_BUSINESS, response.data);
                context.commit(MUTATION_SET_IMPORTED_COMPARTIES_CHILDREN_LOADED_PARTNER_BUSINESS, loadChildren);
            }
        },

        async fetchPartnerRootCompartiesAndChildrenByParentOid(context, { compartyOid, refresh = false }) {

            /*TODO
             * fetch only children and grandchildren for given compartyOid and add to store
             * this is needed when adding chevrons for expand/collapse.
             */

            // fetch all partner root comparties + children and grandchildren for given compartyOid only
            const response = await http.get('/app/helsenett/comparties/' + compartyOid + '/children', {
                params: {
                    ownBusiness: false,
                },
            });

            // all root comparties, only compartyOid has children
            context.commit(MUTATION_SET_IMPORTED_COMPARTIES_PARTNER_BUSINESS, response.data);

        },

        async [ACTION_LOAD_INBOX](context, payload) {
            const source = axios.CancelToken.source();
            if (context.state.inboxLoadCancelTokenSource) {
                context.state.inboxLoadCancelTokenSource.cancel();
            }
            context.commit(MUTATION_SET_INBOX_LOAD_CANCEL_TOKEN_SOURCE, source);

            const promise = http.get('/app/helsenett/edi/messages', {
                cancelToken: source.token,
                params: {
                    page: payload.page,
                    messageBoxType: payload.messageBoxType,
                    messageFilter: payload.messageFilter,
                    clientId: payload.clientId,
                    searchText: payload.searchText,
                    messageTypes: payload.messageTypes,
                },
            });

            promise.then((response) => {
                context.commit(MUTATION_ADD_INBOX_MESSAGES, response.data);
            });

            return promise;
        },

        async [ACTION_CLEAR_INBOX](context) {
            context.commit(MUTATION_EMPTY_INBOX_MESSAGES);
        },

        async [ACTION_ARCHIVE_MESSAGE](context, messageId) {
            const promise = http.post('/app/helsenett/edi/messages/' + messageId + '/archive');

            promise.then(response => {
                context.commit(MUTATION_REMOVE_MESSAGES_BY_ID, response.data);
            });

            return promise;
        },

        async [ACTION_DELETE_MESSAGE](context, messageId) {
            const promise = http.delete('/app/helsenett/edi/messages/' + messageId);

            promise.then(response => {
                context.commit(MUTATION_REMOVE_MESSAGES_BY_ID, response.data);
            });

            return promise;
        },

        async [ACTION_UNARCHIVE_MESSAGE](context, messageId) {
            const promise = http.post('/app/helsenett/edi/messages/' + messageId + '/unarchive');

            promise.then(response => {
                context.commit(MUTATION_REMOVE_MESSAGES_BY_ID, response.data);
            });

            return promise;
        },

        /**
         * Assign a client to a message.
         */
        async [ACTION_ASSIGN_CLIENT](context, { messageId, clientId }) {
            const promise = http.post('/app/helsenett/edi/messages/' + messageId + '/assign-client', {
                clientId: clientId,
            });

            promise.then(response => {
                context.commit(MUTATION_UPDATE_PATIENT_ASSOCIATION, {
                    messageId: messageId,
                    patientAssociation: response.data,
                });
            });

            return promise;
        },

        /**
         * Mark a message as read in the frontend.
         *
         * Do note that we don't need to call the backend. When you fetch the content, we mark a message as read in the
         * backend. So, when you refresh, the UI will be correct. So we only need to mark the message as read in the
         * frontend data, to make the UI responsive.
         */
        async [ACTION_MARK_MESSAGE_AS_READ_IN_FRONTEND](context, messageId) {
            context.commit(MUTATION_MARK_MESSAGE_READ, messageId);
        },

        /**
         * Todo
         */
        async [ACTION_ADDITIONAL_INFORMATION_LOAD](context, messageType) {
            if (
                messageType !== MessageType.ReferralNewState &&
                messageType !== MessageType.ReferralForward
            ) {
                throw new Error('Additional information is not supported for this message type');
            }

            const promise = http.get('/app/helsenett/edi/messages/referral/type-codes', {
                params: {
                    messageType: messageType,
                }
            });

            promise.then(response => {
                context.commit(MUTATION_UPDATE_ADDITIONAL_INFORMATION, {
                    messageType: messageType,
                    data: response.data,
                });

                context.dispatch(ACTION_REFERRAL_SYNC_VISIBLE_FIELDS);
            });

            return promise;
        },

        [ACTION_RESET_UNSAVED_ADDITIONAL_INFORMATION](context) {
            context.commit(MUTATION_RESET_UNSAVED_ADDITIONAL_INFORMATION);
        },

        async [ACTION_SAVE_ADDITIONAL_INFORMATION](context) {
            // In the MVP we don't actually save the data, but we will. So here we will perform the save request.

            context.commit(MUTATION_COMMIT_ADDITIONAL_INFORMATION);
            context.dispatch(ACTION_REFERRAL_SYNC_HAS_ADDITIONAL_INFORMATION);

            // Return the Axios promise when we make an actual HTTP request in this method .
            // We return a dummy promise, so we can make this async from the start, to have less to refactor later.
            return Promise.resolve();
        },

        /**
         * Clears all "additional information" state.
         */
        [ACTION_CLEAR_ADDITIONAL_INFORMATION](context) {
            context.commit(MUTATION_CLEAR_ADDITIONAL_INFORMATION);
            context.commit(MUTATION_RESET_UNSAVED_ADDITIONAL_INFORMATION);
        },

        async [ACTION_GET_SUBMIT](context) {
            let results = {
                infItems: [],
                reasonAsTexts: [],
                dateOfReceiptEvaluation: [],
            };

            const infItemFields = context.state.additionalInformation.infItems;
            if (infItemFields) {
                results.infItems = structuredClone(infItemFields.filter(field => field.visibility !== 'hidden'));
            }

            const reasonAsTextFields = context.state.additionalInformation.reasonAsTexts;
            if (reasonAsTextFields) {
                results.reasonAsTexts = structuredClone(reasonAsTextFields.filter(field => field.visibility !== 'hidden'));
            }

            const dateOfReceiptEvaluationItems = context.state.additionalInformation.dateOfReceiptEvaluation;
            if (dateOfReceiptEvaluationItems) {
                results.dateOfReceiptEvaluation = structuredClone(dateOfReceiptEvaluationItems.filter(field => field.date));
            }

            return Promise.resolve(results);
        },

        async [ACTION_REFERRAL_SET_ADDITIONAL_FIELDS](context, { infItems, reasonAsTexts, dateOfReceiptEvaluation }) {
            context.commit(MUTATION_COMMIT_INF_ITEMS, infItems);
            context.commit(MUTATION_COMMIT_REASON_AS_TEXTS, reasonAsTexts);
            context.commit(MUTATION_COMMIT_DATE_OF_RECEIPT_EVALUATION, dateOfReceiptEvaluation);
        },

        /**
         * Sync field visibility based on loaded message data.
         *
         * We store the message data and field information separately, so when we load a message we need to change
         * the visibility of the fields, based on which data is present.
         */
        async [ACTION_REFERRAL_SYNC_VISIBLE_FIELDS](context) {
            context.commit(MUTATION_COMMIT_REFERRAL_HIDE_ALL_FIELDS);

            if (context.state.referralNewState.referral.patientRelatedContactPerson) {
                context.commit(MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY, {
                    fieldId: ManualAdditionalFields.ReferralPatientRelatedContactPerson,
                    visibility: 'once',
                });
            }

            if (context.state.referralNewState.referral.additionalInformationOnPatient) {
                context.commit(MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY, {
                    fieldId: ManualAdditionalFields.ReferralAdditionalInformationOnPatient,
                    visibility: 'once',
                });
            }

            if (context.state.referralNewState.referral.nextOfKinGuardian) {
                context.commit(MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY, {
                    fieldId: ManualAdditionalFields.ReferralNextOfKinGuardian,
                    visibility: 'once',
                });
            }

            if (context.state.referralNewState.referral.associatedUnit) {
                context.commit(MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY, {
                    fieldId: ManualAdditionalFields.ReferralAssociatedUnit,
                    visibility: 'once',
                });
            }

            if (context.state.referralNewState.referral.infoAssistedCommunication) {
                context.commit(MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY, {
                    fieldId: ManualAdditionalFields.ReferralInfoAssistedCommunication,
                    visibility: 'once',
                });
            }

            if (context.state.referralNewState.referral.informationAboutIndividualPlan) {
                context.commit(MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY, {
                    fieldId: ManualAdditionalFields.ReferralInformationAboutIndividualPlan,
                    visibility: 'once',
                });
            }

            if (context.state.referralNewState.referral.sendDocument) {
                context.commit(MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY, {
                    fieldId: ManualAdditionalFields.ReferralSendDocument,
                    visibility: 'once',
                });
            }

            if (context.state.additionalInformationMessageType === MessageType.ReferralForward) {
                if (context.state.referralNewState.referral.evaluationOfReferral) {
                    context.commit(MUTATION_COMMIT_REFERRAL_MANUAL_FIELD_VISIBILITY, {
                        fieldId: ManualAdditionalFields.ReferralForwardEvaluationOfReferral,
                        visibility: 'once',
                    });
                }
            }

            context.dispatch(ACTION_REFERRAL_SYNC_HAS_ADDITIONAL_INFORMATION);
        },

        /**
         * Iterates through all additional fields and checks if we have any fields visible and commits the result in
         * a boolean variable for easy access in UI components.
         *
         * We could bake this into places where we mutate field visibility so that we don't need to iterate through all
         * the fields here, but that is less readable. I am not worried about the performance of this, but I am
         * concerned about making it easy to understand and maintain.
         */
        [ACTION_REFERRAL_SYNC_HAS_ADDITIONAL_INFORMATION](context) {
            let result = false;

            for (const field of context.state.additionalInformation.infItems) {
                if (field.visibility !== 'hidden') {
                    result = true;
                    break;
                }
            }

            for (const field of context.state.additionalInformation.reasonAsTexts) {
                if (field.visibility !== 'hidden') {
                    result = true;
                    break;
                }
            }

            for (const field of context.state.additionalInformation.manual) {
                if (field.visibility !== 'hidden') {
                    result = true;
                    break;
                }
            }

            context.commit(MUTATION_REFERRAL_SET_HAS_ADDITIONAL_INFORMATION, result);
        },
    },
};

/**
 * Get the key used in the `messages` map/object.
 *
 * This is a hack to keep the order of messages the same as in the array. Integer indices are sorted in ascending
 * numeric order, and we don't want that. If you use a string key, the sort order will be the same as the insert order.
 */
function getMessageStorageKey(messageId) {
    return 'M' + messageId;
}
